import { Col, Row } from "react-bootstrap";
import { IIncidentDetails } from "../../../api/IIncident";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface IncidentDetailsProps {
  incidentDetails: IIncidentDetails;
}

const IncidentDetails = ({ incidentDetails }: IncidentDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"EPA Notified by Licensee"}
            value={incidentDetails.datenotified}
          />
          <EpaField
            label={"First Noticed"}
            value={incidentDetails.firstnoticed}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Incident Start Date and Time"}
            value={incidentDetails.approximatestart}
          />
          <EpaField
            label={"Incident Finish Date and Time"}
            value={incidentDetails.finishtime}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField label={"Date Closed"} value={incidentDetails.closeddate} />
          <EpaField
            label={"Category"}
            value={incidentDetails.incidentcategory}
          />
          <EpaField label={"Nature"} value={incidentDetails.nature} />
        </Col>
        <Col className="col-12 col-md-6"></Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Likelihood of Reoccurrence"}
            value={incidentDetails.likelihoodofreoccurence}
          />
          <EpaField
            label={"Likely Cause"}
            value={incidentDetails.likelycause}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Notified parties"}
            value={incidentDetails.notifiedparties}
          />
          <EpaField
            label={"New / Recurring"}
            value={incidentDetails.newrecurring}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Description (submitted by licensee)"}
            value={incidentDetails.description}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Other Relevant Information (submitted by licensee)"}
            value={incidentDetails.otherrelevantinformation}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Details of Uncontrolled Release (submitted by licensee)"}
            value={incidentDetails.uncontrolledrelease}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Impact on the Environment"}
            value={incidentDetails.impactonenvironment}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Activity at the time of the incident"}
            value={incidentDetails.activityinprogress}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Receptors"}
            value={incidentDetails.receptors}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Details of Vulnerable Receptors"}
            value={incidentDetails.vulnerablereceptors}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Licensed Discharge Point"}
            value={incidentDetails.dischargepoint}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Emission Point Name"}
            value={incidentDetails.emissionpointname}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Discharge Details"}
            value={incidentDetails.dischargedetails}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Incident Details"} content={bodyElements} />;
};

export default IncidentDetails;
